import { useApolloClient } from '@apollo/client/react';
import { Formik } from 'formik';
import NewEmailInvitesForm, { newEmailInvitesSchema } from '../new-email-invites-form';
import { createGroupEmailInvitesMutation, groupInvitesQuery } from '../../apollo/groups';
import type { Group } from '../../types/Group';
import { splitEmailInvitesBody } from '../../utils/invites';

type Props = {
  group?: Group;
  disabled?: boolean;
};

const NewGroupEmailInvites = ({ group, disabled }: Props) => {
  const client = useApolloClient();
  return (
    <Formik
      initialValues={{
        body: ''
      }}
      validationSchema={newEmailInvitesSchema}
      onSubmit={(values, actions) => {
        client.mutate({
          mutation: createGroupEmailInvitesMutation,
          variables: {
            groupId: group.id,
            emails: splitEmailInvitesBody(values.body)
          },
          update: (proxy, { data: { createGroupEmailInvites: newInvites } }) => {
            const listVariables = { slug: group.slug };
            const data = proxy.readQuery({
              query: groupInvitesQuery,
              variables: listVariables
            })
            proxy.writeQuery({
              query: groupInvitesQuery,
              data: {
                ...data,
                group: {
                  ...data.group,
                  emailInvites: [...newInvites, ...data.group.emailInvites]
                }
              },
              variables: listVariables
            })
          }
        }).then(() => {
          actions.setSubmitting(false);
          actions.resetForm();
        }).catch((error) => {
          actions.setSubmitting(false);
          console.log(error);
          // actions.setErrors();
          // actions.setStatus();
        });
      }}
    >
      <NewEmailInvitesForm disabled={disabled} />
    </Formik>
  );
}

export default NewGroupEmailInvites;
